import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getAlertCount = (pcpKeyId: string, companyId: string, timeSpan: string, vendorId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_ALERT_COUNT_REQUEST });

  return api.eligibility.members.getAlertCount(pcpKeyId, companyId, timeSpan, vendorId)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_ALERT_COUNT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_ALERT_COUNT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getForAlertsRow1 = (pcpKeyId: string, companyId: string, timeSpan: string, pageIndex: number, pageSize: number, vendorId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBERS_FOR_ALERTS_ROW_1_REQUEST });

  return api.eligibility.members.getForAlertsRow1(pcpKeyId, companyId, timeSpan, pageIndex, pageSize, vendorId)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBERS_FOR_ALERTS_ROW_1_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBERS_FOR_ALERTS_ROW_1_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getForAlertsRow2 = (pcpKeyId: string, companyId: string, timeSpan: number, pageIndex: number, pageSize: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBERS_FOR_ALERTS_ROW_2_REQUEST });

  return api.eligibility.members.getForAlertsRow2(pcpKeyId, companyId, timeSpan, pageIndex, pageSize)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBERS_FOR_ALERTS_ROW_2_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBERS_FOR_ALERTS_ROW_2_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
